import { Button } from '@frontend/generic-dialpad-accessories';
import { useSoftphoneCallActions } from '../../providers/softphone-call-state-provider/softphone-call-actions.provider';
import { IncomingCall } from '../../types';

type Props = {
  incomingCall?: IncomingCall;
  onEndCall?: () => void;
  onAnswerCall?: () => void;
};

export const IncomingCallBarContent = ({ incomingCall, onEndCall, onAnswerCall }: Props) => {
  const endCall = useSoftphoneCallActions((ctx) => ctx.endCall);
  const answerIncomingCall = useSoftphoneCallActions((ctx) => ctx.answerIncomingCall);

  return (
    <>
      <Button.Round
        onClick={() => {
          if (incomingCall) {
            endCall(incomingCall);
            onEndCall?.();
          }
        }}
        color='red'
        size='small'
        iconName='phone-hangup'
      ></Button.Round>
      <Button.Round
        onClick={() => {
          if (incomingCall) {
            answerIncomingCall(incomingCall);
            onAnswerCall?.();
          }
        }}
        iconName='phone'
        color='green'
        size='small'
      />
    </>
  );
};
